import styled, { css } from "styled-components";


export const FilterButton = styled.button`
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 5px;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 150%;
	background-color: #FFFFFF;
	padding: 8px;
	padding-left: 28px;
	padding-right: 28px;
	height: 42px;
	span {
		padding-left: 8px;
		padding-right: 8px;
	}
	&:hover {
		background: rgba(230, 234, 239, 0.3);
	}
`;


export const FilterWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	min-height: 360px;
	margin-top: 20px;
	padding: 30px;
	gap: 5px;
	flex-shrink: 0;
	border: 1px solid var(--Gray-40, #e1e1e7);
	border-radius: 10px;
	background: var(--Blue-10, #f3f6f9);
	box-shadow: 0px 25px 44px 0px rgba(12, 9, 45, 0.03);
	

`;